window.Promise = window.Promise || require('promise-polyfill').default;



// WEBPACK FOOTER //
// ./src/promise-polyfill.js